export const SELECTION_LETTERS_FETCH_ERROR = 'SELECTION_LETTERS_FETCH_ERROR';
export const SELECTION_LETTERS_FETCHING = 'SELECTION_LETTERS_FETCHING';
export const SELECTION_LETTERS_GET_REPORT = 'SELECTION_LETTERS_GET_REPORT';
export const SELECTION_LETTERS_GET_DATA = 'SELECTION_LETTERS_GET_DATA';
export const SELECTION_LETTERS_SELECTED_HOUSEHOLDS =
  'SELECTION_LETTERS_SELECTED_HOUSEHOLDS';
export const SELECTION_LETTERS_WRITING_TO_DB =
  'SELECTION_LETTERS_WRITING_TO_DB';



// WEBPACK FOOTER //
// ./src/pages/selectionletters/state/selectionletters/types.js